import { Avatar, Tooltip } from "@material-ui/core";
import React from "react";
import useStyles from "./UserAvatar.style";
import { User } from "phosphor-react";

const UserAvatar = ({ avatar, firstName, lastName, avatar2 }) => {
  const classes = useStyles();

  const displayName = [firstName, lastName].filter(Boolean).join(" ") || "User";
  const hasName = Boolean(firstName || lastName);
  const imageClass = avatar2 ? classes.userImage2 : classes.userImage;
  const avatarClass = avatar2 ? classes.avatar2 : classes.avatar;

  if (avatar) {
    return (
      <Tooltip title={displayName}>
        <img className={imageClass} src={avatar} alt="" />
      </Tooltip>
    );
  }

  if (hasName) {
    const initials = [firstName, lastName]
      .map((name) => (name || "").charAt(0).toUpperCase())
      .join("");
    return (
      <Tooltip title={displayName}>
        <Avatar className={avatarClass}>{initials}</Avatar>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="User">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "30px",
          height: "30px",
          borderRadius: "50%",
          border: "1px solid #B1B5C9",
        }}
      >
        <User size={20} color="#B1B5C9" />
      </div>
    </Tooltip>
  );
};

export default UserAvatar;
